import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=78ff831f&"
import script from "./Diagnostic.vue?vue&type=script&lang=ts&"
export * from "./Diagnostic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports